export var FIELD_NAMES = {
    PRODUCTS: 'products',
    SEARCH: 'search',
};
export var isFilterChoiceObject = function (choice) {
    var choiceObj = choice;
    return choiceObj.id !== undefined || choiceObj.name !== undefined;
};
export var isFilterChoiceString = function (choice) {
    return typeof choice == 'string';
};
